import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=5103184c&scoped=true"
import script from "./Exhibition.vue?vue&type=script&lang=js"
export * from "./Exhibition.vue?vue&type=script&lang=js"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=5103184c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103184c",
  null
  
)

export default component.exports